import {
  AmendmentCellDisplay,
  BiomassBurningCellDisplay,
  CashCropCellDisplay,
  CoverCropCellDisplay,
  FertilizerCellDisplay,
  IrrigationCellDisplay,
  LimingCellDisplay,
  LivestockCellDisplay,
  NativeConversionCellDisplay,
  NaturalDisturbanceCellDisplay,
  OwnershipCellDisplay,
  ShipmentDistanceCellDisplay,
  TillageCellDisplay,
  WaterPumpIrrigationCellDisplay,
  WetlandDesignationCellDisplay,
} from '@cibo/landmanager'
import { ComponentType } from 'react'

export const TRAIT_DISPLAY_MAP: Record<string, ComponentType<{ value: any }>> = {
  amendment: AmendmentCellDisplay,
  biomassBurning: BiomassBurningCellDisplay,
  cashCrop: CashCropCellDisplay,
  coverCrop: CoverCropCellDisplay,
  fertilizer: FertilizerCellDisplay,
  includesWetlandDesignation: WetlandDesignationCellDisplay,
  irrigation: IrrigationCellDisplay,
  liming: LimingCellDisplay,
  livestock: LivestockCellDisplay,
  nativeVegetationConversion: NativeConversionCellDisplay,
  naturalDisturbance: NaturalDisturbanceCellDisplay,
  ownership: OwnershipCellDisplay,
  shipmentDistance: ShipmentDistanceCellDisplay,
  tillage: TillageCellDisplay,
  waterPumpIrrigation: WaterPumpIrrigationCellDisplay,
}
